import { create } from "zustand";
import { BookAppointmentPayload } from "../components/interfaces";

interface BookingStore {
  bookingPayload: BookAppointmentPayload | null;
  setBookingPayload: (payload: BookAppointmentPayload) => void;
  updateBookingPayload: (payload: Partial<BookAppointmentPayload>) => void;
  clearBookingPayload: () => void;
}

export const useAppointmentBookingStore = create<BookingStore>((set) => ({
  bookingPayload: null,

  setBookingPayload: (payload) => set({ bookingPayload: payload }),

  updateBookingPayload: (payload) =>
    set((state) => ({
      bookingPayload: {
        ...(state.bookingPayload ?? {}),
        ...payload,
      } as BookAppointmentPayload,
    })),

  clearBookingPayload: () => set({ bookingPayload: null }),
}));
